import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Filter.css'

/**
 * Filter - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Filter extends Component {
  /**
   * Default props
   *
   * @type {{list: Array, selectedProperty: string, useSelect: boolean, showCategories: boolean}}
   */
  static defaultProps = {
    list: [],
    selectedProperty: '',
    showCategories: true,
    useSelect: false
  }

  /**
   * Prop Types
   *
   * @type {{categoriesList: shim, list: *, selectedProperty: *, showCategories: shim, setFilteredList: *, useSelect: shim}}
   */
  static propTypes = {
    categoriesList: PropTypes.array,
    list: PropTypes.object.isRequired,
    selectedProperty: PropTypes.string.isRequired,
    showCategories: PropTypes.bool,
    setFilteredList: PropTypes.func.isRequired,
    setSliderData: PropTypes.func.isRequired,
    useSelect: PropTypes.bool
  }

  /**
   * State
   *
   * @type {{categoriesList: Array, categoriesArray: Array, inputText: string, selectedProperty: string}}
   */
  state = {
    categoriesList: [],
    categoriesArray: [],
    inputText: '',
    selectedProperty: ''
  }

  /**
   * Filter Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.getCategoriesList = this.getCategoriesList.bind(this)
    this.getCategoriesArray = this.getCategoriesArray.bind(this)
    this.selectChange = this.selectChange.bind(this)
    this.inputChange = this.inputChange.bind(this)
    this.categoryClicked = this.categoryClicked.bind(this)
    this.tagClicked = this.tagClicked.bind(this)
    this.filterList = this.filterList.bind(this)
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    const { categoriesList } = this.props

    // let categoriesList = [];
    //
    // if(this.props.categoriesList.length === 0 ) {
    //     categoriesList = this.getCategoriesList(list);
    // } else {
    //     categoriesList = this.props.categoriesList;
    // }
    //
    // let categoriesArray = this.getCategoriesArray(list, categoriesList);

    this.setState({
      categoriesList: categoriesList,
      // categoriesArray: categoriesArray,
      selectedProperty: categoriesList[0].toLowerCase()
    })
  }

  /**
   * Get categories list
   *
   * Loop through the list to get the categories to filter on.
   *
   * @param list
   * @returns {Array}
   */
  getCategoriesList(list) {
    if (list.length === 0) {
      console.log('Error: The list array passed to the Filter is empty.')
      return ['']
    }

    let categoriesList = list
      .map(function(item) {
        return Object.keys(item)
      })
      .reduce(function(pre, cur) {
        return pre.concat(cur)
      })

    // ES6 version of array_unique in PHP
    categoriesList = [...new Set(categoriesList)]

    return categoriesList
  }

  /**
   * Get categories array.
   *
   * Loop through the filter on categories and then nested loop through the list
   * to create an associative array (nested array) of objects which will be
   * the values of all the objects in the list organised by the categories to be filtered on.
   *
   * @param list
   */
  getCategoriesArray(list, categoriesList) {
    return categoriesList.map(function(category) {
      let tagsObj = {}

      // Create an array of tags for each parent category.
      let tags = list.map(function(item) {
        return item[category]
      })

      // Remove falsey values from tags array - empty strings, undefined, null, etc.
      tags = tags.filter(Boolean)

      // Dedupe tags array
      tags = [...new Set(tags)]

      tagsObj[category] = tags

      return tagsObj
    }, list)
  }

  /**
   * Select change
   *
   * @param event
   */
  selectChange(event) {
    let selectedProperty = event.target.options[event.target.selectedIndex].value.toLowerCase()

    this.setState({
      selectedProperty: selectedProperty
    })
  }

  /**
   * Input change event
   *
   * @param event
   */
  inputChange(event) {
    const { list } = this.props
    const { selectedProperty, setFilteredList } = this.state

    let text = event.target.value
    let filteredList = this.filterList(text, list, selectedProperty)

    this.setState({
      inputText: text
    })

    setFilteredList(filteredList)
  }

  /**
   * Category item clicked
   *
   * @param event
   */
  categoryClicked(event) {
    let selectedProperty = event.target.innerHTML.toLowerCase()

    this.setState({
      selectedProperty: selectedProperty
    })
  }

  /**
   * Tag clicked
   *
   * @param event
   */
  tagClicked(event) {
    let tag = event.target.innerHTML.toLowerCase()
    // let selectedProperty = event.target.parentElement.parentElement.firstChild.nodeValue;
    let selectedProperty = 'categories'

    let listItems = event.target.parentElement.children

    for (let i = 0; i < listItems.length; i++) {
      listItems[i].className = ''
    }

    event.target.className = 'active'

    const { list, setFilteredList, setSliderData } = this.props

    let filteredList = {
      cream: [],
      organic: [],
      natural: [],
      pops: []
    }
    let sliderData = []
    let selectedIndex = event.target

    switch (tag) {
      case 'indulgent cream bars':
        filteredList.cream = list.cream
        sliderData = list.cream
        break
      case 'organic crushed fruit bars':
        filteredList.organic = list.organic
        sliderData = list.organic
        break
      case 'natural crushed fruit bars':
        filteredList.natural = list.natural
        sliderData = list.natural
        break
      case 'natural crushed fruit pops':
        filteredList.pops = list.pops
        sliderData = list.pops
        break
      default:
        filteredList = list
        sliderData = [...list.cream, ...list.organic, ...list.natural, ...list.pops]
    }

    setFilteredList(filteredList)
    setSliderData(sliderData, selectedIndex)

    this.setState({
      selectedProperty: selectedProperty
    })
  }

  /**
   * Filter list
   *
   * @param str Text to filter on.
   * @param list An array of objects.
   * @param prop Object property to filter on.
   */
  filterList(str, list, prop) {
    str.toString()

    return list.filter(
      function filterFunc(item) {
        let regex = new RegExp(str, 'ig')
        let result = null

        if (item[prop] !== undefined) {
          result = item[prop].toString().match(regex)
        }

        return result !== null
      },
      str,
      prop
    )
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { useSelect } = this.props
    const { categoriesList, inputText } = this.state

    // let categoryStyleVisibility = 'visible';

    // if (showCategories === false) {
    //     categoryStyleVisibility = 'hidden';
    // }

    // let categoryStyle = {visibility: categoryStyleVisibility};
    // let tagsStyle = {visibility: 'visible'};

    let categoriesMapped = categoriesList.map(
      function(tags, index) {
        let category = categoriesList[index]
        // console.log(category);

        if (useSelect === true) {
          return <option key={index}>{category}</option>
        } else {
          return (
            <li key={index} onClick={this.tagClicked}>
              {category}
            </li>
          )

          /*let tagsMapped = tags[category].map(function (tag, index) {
                    return <li key={index}
                               onClick={this.tagClicked}>{tag}</li>
                }, this);

                return <li key={index}
                           style={categoryStyle}>{category}
                    <ul style={tagsStyle}>{tagsMapped}</ul>
                </li>*/
        }
      },
      this,
      useSelect,
      categoriesList
    )

    return (
      <div className="Filter">
        <label>Filter On </label>

        {useSelect ? <select onChange={this.selectChange}>{categoriesMapped}</select> : <ul>{categoriesMapped}</ul>}

        {useSelect && (
          <div>
            <label>Filter </label>
            <input type="text" value={inputText} onChange={this.inputChange} />
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global/filter/Filter.jsx